import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ResetTheme, SetNavTransparency, SetTheme } from 'src/app/store';

@Injectable({
  providedIn: 'root',
})
export class ResetTopbarGuard {
  constructor(private store: Store) {}
  canActivate() {
    this.store.dispatch(ResetTheme());
    this.store.dispatch(SetNavTransparency({ transparent: false }));
    return true;
  }
}
